// extracted by mini-css-extract-plugin
export var container = "_ax-0";
export var icon = "_ax-1";
export var text = "_ax-2";